import React, { useContext, useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import calender from "../../assets/images/calender.svg";

import moment from "moment";
import DatePicker from "react-datepicker";
import toast from "react-hot-toast";
import "react-phone-input-2/lib/style.css";
import chevRght from '../../assets/images/chev-right.svg';
import Button from "../../components/ui/Button";
import CustomRadioWithTooltip from "../../components/ui/CustomRadioWithTooltip";
import PageLayout from "../../components/ui/PageLayout";
import { ApiConstants } from "../../constants/ApiConstants";
import { Routes } from "../../constants/RouteConstants";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { checkPermission, hasAnySubscription, setDateHelper, getBudgetPeriodDates } from "../../utils/Helper";
import ContributionsDetails from "./ContributionsDetails";
import CustomSplit from "./CustomSplit";
import SelectMonthAndYearModal from "./SelectMonthAndYearModal";
import { PERMISSIONS, UPGRADE_PLAN } from "../../constants/Constants";
import UpgradeToast from "../../components/layouts/UpgradeToast";


interface contributionsInputs {
  start_date: string;
  end_date: string;
  check: any;
}

interface dataTypes {
  rows?: object[];
  total_chores_hours: string | number;
  total_chores_price: string | number;
  total_expenses_price: string | number;
  total_hours_of_employment: string | number;
  total_hours_of_labour: string | number;
  total_unpaid_expenses: string | number;
}

export const divisionOptions = [
  {
    title: "Income-adjusted Split",
    type: "income_based_split",
    tooltipText:
      "For accuracy, all members must enter their income in their profiles in the same manner, whether annual or monthly, or pre-tax or post-tax. Expenses will be split proportionally based on income, and the total value of chores will be split equally.",
    showCapInput: false,
    requiredPermission: PERMISSIONS.INCOME_ADJUSTED_SPLIT,
  },
  {
    title: "Time-adjusted Split",
    type: "time_adjust_split",
    tooltipText: "Time-adjusted Split.",
    showCapInput: true,
    requiredPermission: PERMISSIONS.TIME_ADJUSTED_SPLIT,
  },
  {
    title: "Hybrid-adjusted Split",
    type: "hybrid_adjusted_split",
    tooltipText: "Hybrid-adjusted Split.",
    showCapInput: true,
    requiredPermission: PERMISSIONS.HYBRID_ADJUSTED_SPLIT,
  },
  {
    title: "Even Split",
    type: "equal_split",
    tooltipText:
      "Both the expenses and the total value of chores will be split equally.",
    showCapInput: false,
    requiredPermission: PERMISSIONS.EVEN_SPLIT,
  },
  {
    title: "Custom Split",
    type: "custom_split",
    tooltipText:
      "Enter a customized percentage for each user. The Expenses column and the Chores column must each add up to 100%.",
    showCapInput: false,
    requiredPermission: PERMISSIONS.CUSTOM_SPLIT,
  },
];

const Contributions = () => {
  const contributions = useMakeRequest();
  const checkContribution = useMakeRequest();
  const memberAvailabilityCheck = useMakeRequest();
  const oppertunityCost = useMakeRequest();
  const deleteDeletedMemberChoresAndExpense = useMakeRequest();

  const navigate = useNavigate();

  let profile: any = useContext(authContext);
  const [data, setData] = useState<dataTypes | null>();
  const [selectedMonth, setSelectedMonth] = useState("");
  const [isFinalized, setIsFinalized] = useState(false);
  const [monthFinal, setMonthFinal] = useState(false);
  const [employmentCap, setEmploymentCap] = useState("744");
  const [popupText, setPopupText] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [contributionForm, setContributionForm] = useState<contributionsInputs>(
    {
      start_date: "",
      end_date: "",
      check: null,
    }
  );

  const [selectedDivisionType, setSelectedDivisionType] = useState<
    string | "income_based_split" | "equal_split" | "custom_split" | "time_adjust_split" | "hybrid_adjusted_split"
  >("equal_split");


  const onSubmit = (split: any = null, finalizeValue?: boolean) => {
    if (isFinalized) {
      memberAvailabilityCheck
        .makeRequest({
          payload: {
            household_id: profile?.data?.hh_member?.household?.id,
            start_date: contributionForm.start_date,
            end_date: contributionForm.end_date
          },
          url: ApiConstants?.HouseholdMemberAvailabilityCheck
        })
        .then((res) => {
          console.log("memberAvailabilityCheck res: ", res)
          if (res) {
            _contributionGet(split, finalizeValue);
          }
        }).catch((err) => {
          console.log("memberAvailabilityCheck err: ", err.message)
          if (err) {
            setPopupText(err.message)
            const modal: any = $("#finalizedModal");
            modal.modal("show");
          }

        })
    } else {

      _contributionGet(split, finalizeValue);
    }

  };

  const _contributionGet = (split: any, finalizeValue?: boolean) => {
    const payload: any = {
      ...contributionForm,
      is_finalized: finalizeValue ?? monthFinal,
      type: selectedDivisionType,
    };
    if (selectedDivisionType === "custom_split") {
      payload.split_members = split;
    }
    if (selectedDivisionType === "time_adjust_split" || selectedDivisionType === "hybrid_adjusted_split") {
      payload.cap = employmentCap;
    }


    console.log("payload ==>", payload)
    contributions
      .makeRequest({ payload, url: ApiConstants?.ContributionsGet })
      .catch((err) => {
        console.error(
          "Error while getting contributions data------------->",
          err
        );
      });
    setContributionForm({
      start_date: "",
      end_date: "",
      check: null,
    });
    checkContributionFn();
  }

  const deleteOrphanData = () => {
    deleteDeletedMemberChoresAndExpense.makeRequest({
      payload: {
        household_id: profile?.data?.hh_member?.household?.id,
        start_date: contributionForm.start_date,
        end_date: contributionForm.end_date
      },
      url: ApiConstants?.DeleteDeletedMemberChoresAndExpense
    }).then((res) => {
      if (res) {
        setTimeout(() => {
          _contributionGet(null)
        }, 3000);
      }
    })
  }


  const onView = async (split: any = null) => {
    const payload: any = {
      ...contributionForm,
      type: selectedDivisionType,
    };
    if (selectedDivisionType === "custom_split") {
      payload.split_members = split;
    }
    if (selectedDivisionType === "time_adjust_split" || selectedDivisionType === "hybrid_adjusted_split") {
      payload.cap = employmentCap;
    }


    console.log("payload ==>", payload)
    try {
      // 1️⃣ Recalculate opportunity cost first
      await oppertunityCost.makeRequest({
        url: ApiConstants.OppertunityCostCheck,
        payload: {
          month: moment(contributionForm.start_date).month(),
          start_date: contributionForm.start_date,
          end_date: contributionForm.end_date,
        },
      });

      // 2️⃣ Then fetch contributions
      await contributions.makeRequest({
        payload,
        url: ApiConstants.ContributionsGet,
      });

    } catch (err) {
      console.error("Error refreshing opportunity cost", err);
    }
  };

  useEffect(() => {
    if (contributions?.status) {
      const contributionsData = typeof contributions?.data?.data == 'string' ? JSON.parse(contributions?.data?.data) : contributions?.data?.data
      setData({
        rows: contributionsData.data,
        total_chores_hours: contributionsData.total_chores_hours,
        total_chores_price: contributionsData.total_chores_price,
        total_expenses_price: contributionsData.total_expenses_price,
        total_hours_of_employment:
          contributionsData.total_hours_of_employment,
        total_hours_of_labour: contributionsData.total_hours_of_labour,
        total_unpaid_expenses: contributionsData.total_unpaid_expenses,
      });
      setIsFinalized(contributionsData.is_finalized == 1 ? true : false);
      setSelectedDivisionType(contributionsData.finalized_type);

    } else {
      setData(null);
    }
    if (contributions?.error && !contributions?.error?.data?.income_missing) {
      toast.error(contributions?.error?.message);
    }
    setTimeout(() => {
      checkContributionFn();
    }, 2000);
  }, [contributions?.status, contributions?.error]);

  useEffect(() => {
    return () => {
      $(".modal-backdrop").remove();
    };
  }, []);

  // useEffect(() => {
  //   if (!contributionForm?.start_date && !contributionForm?.end_date) {
  //     const modal: any = $("#selectDateModal");
  //     modal.modal("show");
  //   }
  // }, [contributionForm]);


  useEffect(() => {
    checkContributionFn();
  }, []); // only run once at mount

  const checkContributionFn = () => {
    if (!contributionForm?.start_date && !contributionForm?.end_date) {
      // Calculate current month’s start date based on billingDate
      const { startDate, endDate } = getBudgetPeriodDates(
        moment().year(),
        moment().month(),
        profile?.data?.hh_member?.household?.billing_date || 1
      );

      // ✅ set state so UI shows dates
      setContributionForm({
        start_date: startDate,
        end_date: endDate,
        check: null,
      });

      // ✅ also set current month name
      setSelectedMonth(moment().format("MMMM"));

      checkContribution.makeRequest({
        url: ApiConstants?.ContributionsCheck,
        payload: {
          month: moment().month(),
          year: moment().year(),
          other_params: {
            start_date: startDate,
            end_date: endDate,
            month: moment().month() + 1,
            selected_month: moment().format("MMMM"),
          },
        },
      });
    }
  }

  useEffect(() => {
    if (checkContribution?.status) {
      setContributionForm({
        start_date: checkContribution?.data?.data?.other_params?.start_date,
        end_date: checkContribution?.data?.data?.other_params?.end_date,
        check: {
          finalized_type: checkContribution?.data?.data?.finalized_type,
          is_finalized: checkContribution?.data?.data?.is_finalized,
          can_finalize: checkContribution?.data?.data?.can_finalize
        }
      })
      setIsFinalized(checkContribution?.data?.data?.is_finalized == 1 ? true : false);
      setSelectedDivisionType(checkContribution?.data?.data?.finalized_type || "equal_split");
    }
  }, [checkContribution?.status])

  const userPerms = profile?.data?.plan_perms || profile?.plan_perms;
  const hasOpportunityPermission = checkPermission(userPerms, PERMISSIONS?.OPPORTUNITY_COST);

  const handleAddEditOppertunityCost = () => {
    if (hasOpportunityPermission) {
      navigate(Routes?.OpportunityCost)
    } else {
      toast.dismiss();
      toast.custom((t) => <UpgradeToast t={t} />, {
        id: "upgrade-toast",
        duration: 3000,
      });
    }
  }

  return (
    <>
      <PageLayout headerName='Contributions' onlyTitle={false}>
        {/* <div className="contributions-page"> */}
        {/* <TopHeader headerName="Contributions" /> */}
        <div className="contributions-page">
          <div className="page-padding-x">
            <div className="col-12">
              <div className="com-input-grp">
                {/* <label className="form-label">Select Month</label> */}
                <button
                  type="button"
                  onClick={() => {
                    const modal: any = $("#selectDateModal");
                    modal.modal("show");
                  }}
                  className="mb-3 date-modal-btn"
                  disabled={contributions?.loading || oppertunityCost?.loading}
                >
                  {selectedMonth}
                  <img
                    className="up-down-arw"
                    src={chevRght}
                    alt=""
                  />
                </button>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-6">
                <div className="com-input-grp disabled-input-grp">
                  <label className="form-label">Start Date</label>
                  <DatePicker
                    className="form-control"
                    placeholderText="MM/DD/YYYY"
                    timeFormat="MM DD YYYY"
                    onKeyDown={(e: any) => e.preventDefault()}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={50}
                    disabled
                    selected={contributionForm?.start_date as any}
                    showIcon
                    icon={
                      <>
                        <img className="calIcon" src={calender} alt="" />
                      </>
                    }
                  />
                </div>
              </div>

              <div className="col-6">
                <div className="com-input-grp disabled-input-grp">
                  <label className="form-label">End Date</label>
                  <DatePicker
                    className="form-control"
                    placeholderText="MM/DD/YYYY"
                    timeFormat="MM DD YYYY"
                    onKeyDown={(e: any) => e.preventDefault()}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={50}
                    disabled
                    selected={contributionForm?.end_date as any}
                    showIcon
                    icon={
                      <>
                        <img className="calIcon" src={calender} alt="" />
                      </>
                    }
                  />
                </div>
              </div>
            </div>
            <div
              style={{ width: "100%" }}
              onClick={() => {
                if (!hasOpportunityPermission) {
                  toast.dismiss();
                  toast.custom((t) => <UpgradeToast t={t} />, {
                    id: "upgrade-toast",
                    duration: 3000,
                  });
                }
              }}
            >
              <Button
                disabled={!hasOpportunityPermission}
                className="com-btn me-auto mb-3"
                style={{ width: "100%" }}
                onClick={handleAddEditOppertunityCost}
                loading={false}>
                Add/Edit Opportunity-cost Pricing
              </Button>
            </div>

            <div className="mb-4 com-input-grp">
              <label className="form-label-large mb-3">
                Division of Contributions
              </label>
              {divisionOptions.map((divisionType) => {
                const hasAccess =
                  !divisionType.requiredPermission ||
                  checkPermission(userPerms, divisionType.requiredPermission);
                console.log("userPerms: ", userPerms);
                console.log("hasAccess: ", hasAccess);

                return (
                  <React.Fragment key={divisionType.type}>
                    <div className="form-check com-check mb-3">
                      <CustomRadioWithTooltip
                        id={divisionType.type}
                        name="divisionRadio"
                        value={divisionType.type}
                        label={divisionType.title}
                        disabled={
                          contributions?.loading ||
                          oppertunityCost?.loading ||
                          isFinalized
                        }
                        tooltipText={
                          !hasAccess
                            ? "Please upgrade your plan to use this feature."
                            : divisionType.tooltipText
                        }
                        checked={divisionType.type === selectedDivisionType}
                        onChange={(e) => {
                          if (!hasAccess) {
                            toast.dismiss(); // prevent stacking
                            toast.custom((t) => <UpgradeToast t={t} />, {
                              id: "upgrade-toast",
                              duration: 3000,
                            });
                            return;
                          }

                          setSelectedDivisionType(divisionType.type);
                        }}
                      />
                    </div>

                    {hasAccess &&
                      [divisionType.type].includes(selectedDivisionType) &&
                      divisionType.showCapInput && (
                        <div className="mb-3 d-flex align-items-center">
                          <label htmlFor="employmentCap" className="form-label">
                            Cap on hours of employment
                          </label>
                          <input
                            type="number"
                            id="employmentCap"
                            maxLength={3}
                            className="form-control"
                            placeholder="3 digit"
                            value={employmentCap}
                            min={0}
                            max={744}
                            style={{ width: '5ch', height: '3ch', marginLeft: '10px' }}
                            onChange={(e) => {
                              const val = Number(e.target.value);
                              if (val <= 744) {
                                setEmploymentCap(e.target.value);
                              } else {
                                toast.error("Cap cannot be more than 744 hours");
                              }
                            }}
                          />
                        </div>
                      )}
                  </React.Fragment>
                );
              })}
            </div>
            {contributions?.error?.data?.income_missing ? (
              <p className="text-error">{contributions?.error?.message}</p>
            ) : (
              ""
            )}

            {selectedDivisionType !== "custom_split" ? (
              <div className="page-padding-x">
                <Button
                  className="com-btn"
                  style={{ width: "100%" }}
                  onClick={onView}
                  loading={contributions?.loading || oppertunityCost?.loading}
                >
                  View
                </Button>
              </div>
            ) : (
              ""
            )}
          </div>

          {selectedDivisionType === "custom_split" ? (
            <CustomSplit
              handleSubmit={onSubmit}
              loading={contributions?.loading || oppertunityCost?.loading}
            />
          ) : (
            ""
          )}


          <ContributionsDetails
            data={data as any}
            loading={contributions?.loading || oppertunityCost?.loading}
            isFinalized={isFinalized}
            currentForm={contributionForm}
            onFinalize={(val) => {
              setMonthFinal(val)
            }}
            onPressSubmit={(split, val) => onSubmit(split, val)}
          />

        </div>

        {/* </div> */}
      </PageLayout>
      <SelectMonthAndYearModal
        billingDate={profile?.data?.hh_member?.household?.billing_date}
        onContinue={(e: any) => {
          setContributionForm(e);
          contributions.reset();
          setIsFinalized(e.check.is_finalized == 1 ? true : false);
          setSelectedDivisionType(e.check.finalized_type || "equal_split");
        }}
        selectMonth={setSelectedMonth}
      />



      {/*==== Finalized Modal Box Start ====*/}
      <div className="modal fade inner-modal com-modal" id="finalizedModal" tabIndex={-1} aria-labelledby="finalizedModalLabel" aria-hidden="true" >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-body pt-4 pb-0">
              <p className="com-modal-para mb-2 mt-3">
                {popupText}
              </p>
            </div>
            <div className="modal-footer border-0 mt-3 justify-content-center">
              <button type="button" className="com-btn com-btn-gray btn-close-cancelSubscription" id="btn-close-modal" data-bs-dismiss="modal" >
                Cancel
              </button>
              <button type="button" className="com-btn" data-bs-dismiss="modal" onClick={() => deleteOrphanData()} >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
      {/*==== Finalized Modal Box End ====*/}
    </>
  );
};

export default Contributions;
